var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#FB9319"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H7.99974V4.99436L7.49981 8.4845H6.49994L6 4.99436V3ZM7.99974 9.98027C8.00276 10.1131 7.97913 10.2451 7.93027 10.3687C7.8814 10.4923 7.80827 10.6048 7.71518 10.6998C7.62208 10.7948 7.5109 10.8703 7.38815 10.9219C7.2654 10.9734 7.13356 11 7.00038 11C6.86719 11 6.73534 10.9735 6.61257 10.922C6.48979 10.8706 6.37857 10.7951 6.28543 10.7002C6.19228 10.6052 6.1191 10.4927 6.07017 10.3692C6.02124 10.2456 5.99756 10.1136 6.0005 9.98077C6.00628 9.72023 6.1141 9.47229 6.30088 9.29004C6.48766 9.10779 6.73857 9.0057 6.99988 9.00564C7.26119 9.00557 7.51214 9.10753 7.69902 9.28969C7.88589 9.47185 7.99384 9.71973 7.99974 9.98027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.b6fc46d99caeaa99b3495157dee03c24.svg";
export { ForwardRef as ReactComponent };